<template>
  <div class="d-flex flex-column fill-height">
    <div class="flex-grow-1 d-flex justify-center align-center video-container" ref="video-container">
      <video class="preview" ref="video-preview" muted />
      <div class="count-in" v-if="count">{{count}}</div>
    </div>

    <div class="flex-grow-0 d-flex pa-4">
      <media-source-menu @change="changeMediaSource" :disabled="isRecording" />
      <v-spacer />
      <!-- Note: I want this button to be temporary, and this method of removing the focus is only semi-effective -->
      <v-btn fab @click="toggleRecording" :dark="isRecording" @focus="e => e.target.blur()" :disabled="!recorder">
        <v-icon color="red">mdi-record</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn fab @click="save" :disabled="isRecording || recordedData.length === 0">
        <v-icon color="red">mdi-cloud-upload</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
.video-container {
  height: 0;
  overflow: hidden;
}
video.preview {
  background-color: black;
  object-fit: contain;
  height: 100%;
}
.count-in {
  position: absolute;
  color: #fff;
  font-size: 256px;
  font-weight: bold;
}
</style>

<script>
import MediaSourceMenu from '@/components/MediaSourceMenu.vue';

export default {
  name: 'create',
  components: {
    MediaSourceMenu
  },
  props: [ 'chainPostId' ],
  data() {
    return {
      count: null,
      countTimeout: null,
      isRecording: false,
      recorder: null,
      recordedData: []
    };
  },
  computed: {
  },
  methods: {
    changeMediaSource(stream) {
      // if (this.$refs['video-preview'].srcObject) {
      //   this.$refs['video-preview'].srcObject.getTracks().forEach(track => track.stop());
      // }
      // if (stream) {
      //   this.$refs['video-preview'].srcObject = stream;
      //   this.$refs['video-preview'].play();
      //   this.recorder = new MediaRecorder(stream, { mimeType: 'video/webm;codecs=vp9' });
      //   this.recorder.ondataavailable = e => this.recordedData.push(e.data);
      // } else {
      //   this.recorder = null;
      // }
    },
    countDown() {
      this.countTimeout = null;
      this.count--;
      if (!this.count) {
        this.recorder.start();
      } else {
        this.countTimeout = window.setTimeout(this.countDown, 1000);
      }
    },
    toggleRecording() {
      if (this.isRecording) {
        this.isRecording = false;
        if (this.countTimeout) {
          this.count = null;
          window.clearTimeout(this.countTimeout);
        } else {
          // TODO: see if there's anything to save
          this.recorder.stop();
          console.log(this.recordedData)
        }
      } else {
        this.isRecording = true;
        this.recordedData = [];
        this.count = 3;
        this.countTimeout = window.setTimeout(this.countDown, 1000);
      }
    },
    save() {
      // TODO: something with the recorded data
    },
    resize() {
      const w = 9 * this.$refs['video-preview'].offsetHeight / 16;
      this.$refs['video-preview'].style.width = w + 'px';
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
  mounted() {
    this.$nextTick(this.resize);
    window.addEventListener('resize', this.resize);
  }
}
</script>
